import { DeleteForeverOutlined, InfoOutlined } from "@mui/icons-material";
import { Box, Button, IconButton, Stack, Typography } from "@mui/material";

export const ButtonLargeSquare = ({
  icon,
  title,
  subHeader,
  subHeader2,
  onClick,

  action,
  actionIcon,

  sx,
  disabled,

  props,
  dataTestid,

  actionButton,
  actionButtonText,
}) => {
  return (
    <Box sx={{ position: "relative", height: "100%" }}>
      <Button
        fullWidth
        {...props}
        onClick={onClick}
        className="buttonLargeSquare"
        variant="text"
        sx={{
          ...sx,
          bgcolor: "background.paper",
          borderColor: "grey.200",
          borderRadius: 1,
          borderWidth: 1,
          borderStyle: "solid",
          "&:hover": { bgcolor: "background.paper", borderColor: "grey.200", boxShadow: 1 },
        }}
        disabled={disabled}
        data-testid={dataTestid || title}
      >
        <Stack display="flex" direction="column" spacing={1} alignItems="center" justifyItems="center" gap={1}>
          {icon || <InfoOutlined />}

          <Box alignContent="center">
            <Typography variant="subtitle1" className="mb-2" fontWeight={600} color="text.primary">
              {title}
            </Typography>
          </Box>
          {subHeader2 && subHeader2.trim() !== "" && (
            <Box alignContent="center">
              <Typography variant="subtitle2" fontWeight={400} color="text.secondary" sx={{ whiteSpace: "pre-wrap" }}>
                {subHeader2}
              </Typography>
            </Box>
          )}
          {subHeader && subHeader.trim() !== "" && (
            <Box alignContent="center">
              <Typography variant="subtitle2" fontWeight={400} color="text.secondary" sx={{ whiteSpace: "pre-wrap" }}>
                {subHeader}
              </Typography>
            </Box>
          )}
          {action && actionButton && (
            <Button
              component="div"
              className="upload_file_button"
              variant="outlined"
              color="primary"
              fullWidth
              data-testid={`action for ${dataTestid || title}`}
              onClick={(e) => {
                e.stopPropagation();
                action?.();
              }}
              disabled={disabled && !action}
            >
              {actionButtonText || "Upload File"}
            </Button>
          )}
        </Stack>
      </Button>
      {(action || actionIcon) && !actionButtonText && (
        <Box sx={{ position: "absolute", top: 0, right: 0, p: "2px" }}>
          <IconButton
            data-testid={`action for ${dataTestid || title}`}
            onClick={(e) => {
              e.stopPropagation();
              action?.();
            }}
            disabled={disabled && !action}
          >
            {actionIcon || <DeleteForeverOutlined />}
          </IconButton>
        </Box>
      )}
    </Box>
  );
};
